import classNames from 'code-micro/utils/classNames';
export default function GloLayoutA({
    id,
    className,
    children,
    data = {},
    style,
    isFixedWidthCenterV1 = false,
    isFixedWidthCenterV2 = false,
}: {
    id: string;
    className: string;
    children?: React.ReactNode;
    data?: any;
    style?: React.CSSProperties;
    isFixedWidthCenterV1?: boolean; // 是否开启容器整体固定1200px并居中
    isFixedWidthCenterV2?: boolean; // 是否开启容器整体固定1440px并居中
}) {
    const compStyle: any = {
        '--editor-section-containerBg': data.containerBg,
        '--editor-section-containerMaxWidth': data.containerMaxWidth,
        ...style,
    };
    const compCls = classNames('editor-section', {
        [`editor-${id}`]: id,
        [`editor-section-container-v1`]: isFixedWidthCenterV1,
        [`editor-section-container-v2`]: isFixedWidthCenterV2,
        [`${className}`]: className,
    });
    return (
        <section id={`editor-${id}`} className={compCls} style={compStyle}>
            <div className="editor-section-container">{children}</div>
        </section>
    );
}
